import type { SelectedBundleOption } from '@cobrastyle/shared-types';
import { Text } from '@cobrastyle/ui';

interface BundleOptionsSummaryProps {
  options: SelectedBundleOption[];
  className?: string;
}

/**
 * Lists the customer's chosen bundle selections on a cart line — one line per
 * option group ("Vapen: Sabatti Forest"), with a ×N suffix when a selection's
 * quantity is greater than one. Shared by the mini-cart and the full cart page.
 */
export function BundleOptionsSummary({ options, className }: BundleOptionsSummaryProps) {
  if (!options?.length) return null;

  return (
    <div className={className}>
      {options.map((opt, i) => (
        <Text key={`${opt.label}-${i}`} size="xs" variant="muted" className="truncate">
          <span className="font-medium">{opt.label}:</span>{' '}
          {opt.values
            .map((v) => (v.quantity > 1 ? `${v.label} ×${v.quantity}` : v.label))
            .join(', ')}
        </Text>
      ))}
    </div>
  );
}
